import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'sg-counter-badge',
  templateUrl: './sg-counter-badge.component.html',
  styleUrls: ['./sg-counter-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgCounterBadgeComponent {
  @Input() value: number;
  @Input() color: 'on-color' | 'info' | 'error' | 'empty' | 'turquoise' | 'sky-blue' = 'info';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() variant: 'counter' | 'dot' = 'counter';

  get strBadge(): string {
    return this.value > 99 ? '99+' : this.value.toString();
  }
}
